import { IconName } from '../components/Icon'

export const plural = (type: string) => {
    switch (type) {
        case 'class':
            return 'classes'
        case 'category':
            return 'categories'
        default:
            return `${type}s`
    }
}

export const getIconNameFromType = (type: string): IconName => {
    switch (type) {
        case 'category':
            return 'library'
        case 'product':
            return 'package'
        case 'service':
            return 'tag'
        case 'class':
            return 'student'
        case 'package':
            return 'package2'
        case 'gift':
            return 'gift'
        case 'subscription':
            return 'refresh'
        case 'reservation':
            return 'calendarClock'
        default:
            return 'tag'
    }
}
